import { createUseStyles } from 'react-jss';
import { Classes } from 'jss';
import { ActionPalette } from '@tcl-boron-colors/colors';
import { StatusVariant } from '@tcl-argon-utils/utils';

export interface DropdownStylesData {
  isDisabled: boolean;
  isPrimary: boolean;
  status: StatusVariant;
  isEmpty: boolean;
  isLoading: boolean;
}
export const useHierarchicalStyles: (data: DropdownStylesData & { theme?: Jss.Theme }) => Classes<'linkButton'> =
  createUseStyles({
    virtualScrollRows: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
    },
    flexbox: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
    flexboxWrap: {
      flexWrap: 'wrap',
      alignContent: 'flex-start',
    },
    linkButton: {
      outline: 'none',
      border: 'none',
      cursor: 'pointer',
      backgroundColor: 'transparent',
      color: ActionPalette[300],
      fontWeight: '500',
      textDecoration: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      paddingLeft: '12px',
      height: '12px',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    backLinkButton: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      color: ActionPalette[300],
      cursor: 'pointer',
      paddingBottom: '12px',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    parentLinkButton: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      color: ActionPalette[300],
      paddingBottom: '6px',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    parentLinkButtonMulti: {
      paddingLeft: '26px',
    },
    parentLinkButtonSingle: {
      paddingLeft: '0px',
    },
    boldedLabelHierarchicalWithLink: {
      paddingBottom: '0px',
      paddingTop: '0px',
      lineHeight: '16px',
    },
    toggle: {
      height: '35px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    svgCaret: {
      marginRight: '8px',
      marginLeft: '12px',
      paddingTop: '12px',
      paddingBottom: '12px',
      minHeight: '34px',
    },
  });
